import { ref } from "vue"
// import firebase from "firebase/app";

export default function () {
    const user = ref()
    const auth = window.firebaseAuth;

    const provider = new window.GoogleAuthProvider()
    provider.addScope('profile');
    provider.addScope('email');

    const signInWithPopup = function () {
        return new Promise((resolve, reject) => {
            auth.signInWithPopup(provider).then((result) => {
                var _user = result.user;
                if (_user) {
                    user.value = _user
                }

                if (result.credential) {
                    /** @type {firebase.auth.OAuthCredential} */
                    var credential = result.credential;

                    // This gives you a Google Access Token. You can use it to access the Google API.
                    resolve(credential);
                    // ...
                } else {
                    resolve(null)
                }
                // ...
            }).catch((error) => {
                reject(error)
            });

        })
    }

    const signInWithRedirect = function () {
        auth.signInWithRedirect(provider);
    }

    const getAuthUser = function() {
        return new Promise((resolve) => {
            var _user = auth.currentUser;
            if (_user) {
                user.value = _user
                
            }
            resolve(_user);
        })
    }

    const getGoogleIdToken = function() {
        return new Promise((resolve, reject) => {
            auth.currentUser.getIdToken().then((idToken) => {
                resolve(idToken);
                // idToken can be passed back to server.
            }).catch((error) => {
                    // Error occurred.
                reject(error)
            });
        })
    }

    const getRedirectResult = function () {
        return new Promise((resolve, reject) => {
            auth.getRedirectResult().then((result) => {
                // The signed-in user info.
                var _user = result.user;
                if (_user) {
                    user.value = _user
                }

                if (result.credential) {
                    /** @type {firebase.auth.OAuthCredential} */
                    var credential = result.credential;

                    // This gives you a Google Access Token. You can use it to access the Google API.
                    resolve(credential);
                    // ...
                } else {
                    resolve(null)
                }
            }).catch((error) => {
                user.value = null
                reject(error)
                // Handle Errors here.
                // var errorCode = error.code;
                // var errorMessage = error.message;
                // // The email of the user's account used.
                // var email = error.email;
                // // The firebase.auth.AuthCredential type that was used.
                // var credential = error.credential;
                // ...
            });

        })
    }

    return {
        user,
        signInWithPopup,
        signInWithRedirect,
        getRedirectResult,
        getAuthUser,
        getGoogleIdToken
    }
}
